import { Global } from '../global';
import { UtilityService } from '../../services/Acc_Utility.service';
import { Component, OnInit  } from '@angular/core';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';


@Component({
    selector: 'home',
    templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {
startDate = new Date(2018,3, 14);
events: string[] = [];


  ArrLabels: any;
  labels: any = {};

    constructor(
    private UtilityService: UtilityService,
    private global:Global,
    private adapter: DateAdapter<any>,
    ) { }

   

    ngOnInit() {
        this.getLabels();
    }

    fa() {
        console.log('fa');
        this.adapter.setLocale('ps-AR');
        
      }
    addEvent(type: string, event: MatDatepickerInputEvent<Date>) {
        this.events.push(`${type}: ${event.value}`);
        console.log(`${type}: ${event.value}` );
      }

    getLabels(){
        this.UtilityService.getLabels('home',this.global.lang)
          .subscribe(response => {
              if(response){
                  this.ArrLabels = response;
                  this.setLabels();
              }
          },
          error => console.log(error))
        }
    
      setLabels(){
    
        this.labels['home-Title'] = this.ArrLabels.find( (o:any) => o.key === 'home-Title').value;
    
      }
    
}

export const Dari = {
    calendarLabel: 'test',
    nextMonthLabel: 'next',
    nextYearLabel: 'next',
    openCalendarLabel: 'open',
    switchToMonthViewLabel: 'switch'
  }
  


// WEBPACK FOOTER //
// ./src/app/components/home/home.component.ts